export default __webpack_public_path__ + "static/media/dekstop-prakerja.0196ee2a.png";